<template>
  <aside class="flex flex-col justify-between items-center py-100">
    <slot />

    <nav v-if="metaLinks.length">
      <ul
        class="list flex justify-between"
        :class="{ 'list-no-margin-bottom': noMarginBottom }"
        data-testid="meta-links-list"
      >
        <li v-for="link in metaLinks" :key="link.title">
          <LcButton
            class="meta-link"
            data-testid="meta-links-link"
            :icon="link.icon"
            no-padding
            size="small"
            tabindex="0"
            :to="link.route"
            variant="tertiary"
          >
            {{ link.title }}
          </LcButton>
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script lang="ts" setup>
import type { LcIconName } from '@lottocom/frontend-components'

type MetaLink = {
  icon: LcIconName
  route: string
  show: boolean
  title: string
}

type MetaLinksProps = {
  hideFaq?: boolean
  hidePrizes?: boolean
  hideRules?: boolean
  noMarginBottom?: boolean
}

const {
  hideFaq = false,
  hidePrizes = false,
  hideRules = false,
  noMarginBottom = false,
} = defineProps<MetaLinksProps>()

const { path } = useRoute()
const { t } = useI18n()

const metaLinks = computed<MetaLink[]>(() => {
  const entries: MetaLink[] = [
    {
      icon: 'info',
      route: `${path}/info/rules`,
      show: !hideRules,
      title: t('metalinks.link.rules', 2),
    },
    {
      icon: 'prize',
      route: `${path}/info/prizes`,
      show: !hidePrizes,
      title: t('metalinks.link.prizes', 2),
    },
    {
      icon: 'question',
      route: `${path}/info/faq`,
      show: !hideFaq,
      title: t('metalinks.link.faq'),
    },
  ]

  return entries.filter((entry) => entry.show)
})
</script>

<style lang="scss" scoped>
.list {
  gap: token('size/space/gap/400');
  margin-bottom: $main-bottom-navigation-height;
  padding: {
    right: token('size/space/gap/200');
    left: token('size/space/gap/200');
  }

  .meta-link {
    padding: token('size/space/gap/none');
  }

  @include media-mobile-small {
    gap: token('size/space/gap/150');
    padding: token('size/space/gap/none');
  }

  &-no-margin-bottom {
    margin-bottom: token('size/space/gap/none');
  }
}
</style>
